import React, { useEffect } from 'react';

const ReviewWidget = ({ product }) => {
  useEffect(() => {
    // Avoid reloading the script if already loaded
    if (!document.querySelector('script[src="https://app.ravecapture.com/assets/js/trustspot_product_reviews.js"]')) {
      // Set the trustspot_key
      const trustspotScript = document.createElement('script');
      trustspotScript.type = 'text/javascript';
      trustspotScript.textContent =
        "trustspot_key = '133e3410d159c6d822175e98ad15c03cd2f2b7cdf407c0374a59c982ff559a53433421b0ffaa4fc9a38884ba3f30da22c7cddfbebff4f21ef42c22a771bc215b';";
      document.head.appendChild(trustspotScript);

      // Add the RaveCapture script
      const raveScript = document.createElement('script');
      raveScript.src = 'https://app.ravecapture.com/assets/js/trustspot_product_reviews.js';
      raveScript.async = true;
      document.head.appendChild(raveScript);
    }
  }, []);

  return (
    <div
      className="trustspot trustspot-main-widget"
      data-product-sku={product.id} // Use product.id for SKU
      data-name={product.name} // Use product.name
      data-url={product.url} // Use product.url
      data-image-url={product.image} // Use product.imageUrl
      data-description={product.shortDescription} // Use product.description
    ></div>
  );
};

export default ReviewWidget;
